export const DEFAULT = '/';
export const MFA = '/mfa';
export const DASHBOARD = '/dashboard';
export const LOGIN = '/login';
export const TRANSFERS = '/transfers';
export const CARD = '/card';
export const CARD_DETAIL = '/card/:id';
export const CARD_TRACKING = '/card/tracking';
export const CARD_TRACKING_DETAIL = '/card/tracking/:suitcase_uuid';
export const TEAM = '/team';
export const CREDITS = '/credit';
export const ONBOARDING_INVITE = '/onboarding/invite';
export const ONBOARDING_USER = '/onboarding/user';
export const USER_INVITATION_VALIDATE_V1 = '/user/invitation/validate@1.0';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_PASSWORD = '/reset-password';
export const ADMIN_INVITE = '/admin-invite';
